var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbActive1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.33333V8.66667H14V7.33333H16.6667ZM10 7.33333V11.3333H7.33333V7.33333H10ZM16.6667 12.6667V16.6667H14V12.6667H16.6667ZM10 15.3333V16.6667H7.33333V15.3333H10ZM18 6H12.6667V10H18V6ZM11.3333 6H6V12.6667H11.3333V6ZM18 11.3333H12.6667V18H18V11.3333ZM11.3333 14H6V18H11.3333V14Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbActive1);
export default __webpack_public_path__ + "static/media/DBActive1.4ff036917fbb76b8497b7485dbe7f509.svg";
export { ForwardRef as ReactComponent };